<div class="roots-loader" role="status" aria-live="polite" aria-busy="true">
  <div class="roots-loader-mark" aria-hidden="true">
    <span class="roots-loader-ring"></span>
    <img src="assets/images/earthscoutIcon.PNG" alt="" width="28" height="28">
  </div>
  <span class="roots-loader-label">Loading…</span>
</div>
